import React from "react";
import _ from "underscore";
import { optional, uuid } from "../../utils/lang";
import { SortableElement, SortableContainer } from "react-sortable-hoc";

const SortableItem = SortableElement(({item}) => {
    return (
        <div
            className="sortable-list__item"
        >
            {item.content}
        </div>
    )
});

const SortableList = SortableContainer(({items, uuid}) => {
    return (<div
            className="sortable-list__list"
        >
            {items.map((item, index) => {
                return (<SortableItem
                        key={`list-${uuid}-item-${index}`}
                        index={index}
                        item={item}
                    />)
            })}
        </div>);
});

export default class ScrollableList extends React.Component {
    constructor(props) {
        super(props);
        this.listRef = React.createRef();
        this.uuid = uuid();
    }

    onChange(data) {
        const {oldIndex, newIndex} = data;
        if (this.props.onChange && _.isFunction(this.props.onChange)) {
            const items = [...optional(this.props.items, [])],
                [item] = items.splice(oldIndex, 1);

            items.splice(newIndex, 0, item);
            this.props.onChange(items);
        }
    }

    render() {
        const items = optional(this.props.items, []);

        let className = "sortable-list__wrapper";

        if (this.props.className) {
            className += " " + className;
        }

        return (
            <div
                ref={this.listRef}
                className={className}
            >
                <SortableList
                    helperContainer={this.listRef.current}
                    uuid={this.uuid}
                    items={items}
                    onSortEnd={this.onChange.bind(this)}
                />
            </div>
        )
    }
}